import { useEffect, useRef, useState } from 'react'
import styles from './input-password.module.scss'
import { Icon } from '@lib-components'
interface InputPasswordIframeProps {
  label: string
  name: string
  error?: string
  onChange: (value: string) => void
  disabled?: boolean
  required?: boolean
}
export const InputPasswordIframe = ({
  label,
  name,
  error,
  onChange,
  disabled = false,
  required = true,
}: InputPasswordIframeProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [showPassword, setShowPassword] = useState(false)
  const [hasContent, setHasContent] = useState(false)
  const [hasFocus, setHasFocus] = useState(false)
  const IFRAME_ORIGIN = window.location.origin

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.origin !== IFRAME_ORIGIN) return
      if (event.data?.field === 'password') {
        const value = event.data.value
        setHasContent(!!value)
        onChange(value)
      }
      if (event.data?.type === 'iframe-focus') {
        setHasFocus(true)
      }
      if (event.data?.type === 'iframe-blur') {
        setHasFocus(false)
      }
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [onChange, IFRAME_ORIGIN])
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev)
    iframeRef.current?.contentWindow?.postMessage(
      { action: 'toggle' },
      IFRAME_ORIGIN
    )
  }
  const inputClass = error ? styles['form-field-error'] : styles['form-field']
  const labelClass = required
    ? `${styles['form-label']} ${styles['form-label--required']}`
    : styles['form-label']
  return (
    <div className={styles['form-group']}>
      <button
        aria-label="Mostrar/Ocultar contraseña"
        className={styles['form-icon']}
        tabIndex={-1}
        disabled={disabled}
        type="button"
        onClick={toggleShowPassword}
      >
        <Icon name={showPassword ? 'visibility_off' : 'visibility'} />
      </button>
      <iframe
        ref={iframeRef}
        title="Campo seguro"
        src="/password-field.html"
        className={inputClass}
        name={name}
        style={{
          width: '100%',
          height: '46px',
          borderRadius: '4px',
          background: 'white',
        }}
      />
      <label
        htmlFor={name}
        className={labelClass}
        style={{
          top: hasFocus || hasContent ? '-10px' : '14px',
          fontSize: '16px',
        }}
      >
        {label}
      </label>
      {error && (
        <span
          className={`${styles['form-message']} ${styles['form-message--visible']} ${styles['form-message--error']}`}
        >
          {error}
        </span>
      )}
    </div>
  )
}
